import React from 'react';

export const ColumnasDinamicas = ({ columnas = [] }) => {
    
    if (!columnas || columnas.length === 0) return null;

    return (
        <div className="flex flex-col sm:flex-row gap-4 w-full mt-1">
            {columnas.map((col, index) => {
                const textoOriginal = col.valor || 'No registrado';

                return (
                    <React.Fragment key={index}>
                        <div className="flex-1 min-w-0">
                            {/* CAMBIO CLAVE: Movimos el title AQUÍ. 
                                Ahora solo la etiqueta truncada muestra el tooltip con su texto completo */}
                            <span 
                                className="text-[10px] text-slate-400 block font-medium uppercase tracking-wider mb-0.5 select-none max-w-[40ch] truncate cursor-help"
                                title={col.etiqueta}
                            >
                                {col.etiqueta}
                            </span>
                            
                            {/* El valor queda limpio y se adapta al espacio */}
                            <div className="text-sm font-bold text-slate-800 block max-w-[40ch] truncate">
                                {textoOriginal}
                            </div>
                        </div>

                        {/* Línea divisoria vertical */}
                        {index < columnas.length - 1 && (
                            <div className="hidden sm:block w-px bg-slate-200 self-stretch my-1" />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};